<template>
  <div class="container">
    <nyTit1 pathUrl="/sanchan1_hongshu" />
    <div class="content">
      <!-- 左侧 -->
      <div class="leftBox">
        <div class="title">
          <span class="txt1">三产融合</span
          ><span class="txt2">Integration of three industries</span>
        </div>
        <!-- 过去6年丝瓜总产值 -->
        <div class="leftBox3">
          <div class="title1">电商引领  创新驱动  三产融合  上蔡样板</div>
          <div class="left_list">
            <div v-for="(item,index) in leftData" :key="index" class="left_list_item0">
              <div class="left_list_item">
                <h5>{{item.title}}</h5>
                <div class="left_list_item_bottom">
                  <img :src="item.icon" class="left_list_item_l" :style="index==0?'margin-top:-20px':''">
                  <div class="left_list_item_r">
                    <div class="left_list_item_r_item" v-for="(item0,index0) in item.list" :key="index0"><span>{{index0+1}}</span><span v-html="item0"></span></div>
                  </div>
              </div>
              
            </div>
            <img src="../assets/img/sanchan1/jt1.png" class="jiantouLeft" v-if="index!=2" />
            </div> 
          </div>
        </div>

      </div>
      <!--中间-->
      <div class="center">
        <div class="jian_kong_fc1"><span>成功孵化企业“巨型一号”产业链场景展示</span></div>
        <div class="img1 img">
          <vue3VideoPlay
            id="video"
            ref="videoRef"
            width="100%"
            height="100%"
            title="视频监控"
            :src="options.src"
            :type="options.type"
            :autoPlay="false"
            :muted="true"
            :control="false"
            :loop="true"
            @loadedmetadata="onLoadedMetadata"
          />

          <div class="jian_kong_fc">巨型一号直播间</div>
        </div>
        <img src="../assets/img/sanchan1/jt.png" class="jiantou" />
        <div class="img2 img">
          <!-- <img src="../assets/img/sanchan1/cp.jpg" /> -->
          <vue3VideoPlay
            id="video"
            ref="videoRef"
            width="100%"
            height="100%"
            title="视频监控"
            :src="options1.src"
            :type="options1.type"
            :autoPlay="false"
            :muted="true"
            :control="false"
            @loadedmetadata="onLoadedMetadata"
          />
          <div class="jian_kong_fc">巨型一号加工基地</div>
        </div>
        <img src="../assets/img/sanchan1/jt.png" class="jiantou" />
        <div class="img3 img">
          <!-- img src="../assets/img/sanchan1/zz.jpg" /> -->
          <vue3VideoPlay
            id="video"
            ref="videoRef"
            width="100%"
            height="100%"
            title="视频监控"
            :src="options2.src"
            :type="options2.type"
            :autoPlay="false"
            :muted="true"
            :control="false"
            @loadedmetadata="onLoadedMetadata"
          />
          <div class="jian_kong_fc"><span>巨型一号种植基地</span></div>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="rightBox">
        <div class="title">
            <span class="txt1">产品销售信息</span >
            <!-- <span class="txt2">Output value of processing industry</span> -->
          </div>
        <!-- 丝瓜产业大数据 -->
        <div class="leftBox1">
          <div class="leftContent1">
            <div  class="leftContent1_item"  v-for="(item, index) in leftData1"  :key="index">
              <span class="leftContent1_item_name">{{ item.name }}</span><span class="leftContent1_item_value">{{ item.value }}<i>{{ item.unit }}</i></span>
            </div>
          </div>
        </div>
        <!-- 年度电销订单量 -->
        <div class="leftBox2">
          <div class="title1">2025年度产品销售情况</div>
          <div class="echartBox"><leftPie /></div>
        </div>
        <div class="rightBox1">
          <div class="title">
            <span class="txt1">加工业产值</span
            ><span class="txt2">Output value of processing industry</span>
          </div>
          <div class="title1" style="margin-top: 12px">
            近5年丝瓜类产品加工业产值
          </div>
          <div class="echartBox rightContent1">
            <!-- <dv-scroll-board
              :config="config"
              style="width: 100%; height: 100%"
              @click="tabcp"
            /> -->
            <leftLine />
          </div>

          <!-- 六个产品导航开始 -->
          <!-- <div class="dao_hang">
            <div
              class="biao_ti_name"
              v-for="(item, index) in tData6"
              :key="index"
            >
             <router-link :to="{ path: item.path }"  >{{ item.name }}</router-link> 
            </div>
          </div> -->
          <!-- 六个产品导航结束 -->
        </div>
        <div class="rightBox2">
          <div class="title">
            <span class="txt1">产品种植信息</span
            ><span class="txt2">Product planting information</span>
          </div>
          <div class="title1 rightTit">丝瓜作物种植信息</div>
          <div class="area">
            <div class="area_left">
              <img src="../assets/img/sanchan1/zt.png" />目前种植面积
            </div>
            <div class="area_right"><span>1650</span>亩</div>
          </div>
          <div class="echartBox"><rightPie /></div>
        </div>
      </div>
    </div>
  </div>
<!--  <footer1 />-->
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import * as THREE from "three";
import { useRouter } from "vue-router";
import countTo from "@/components/vue-count-to/src/vue-countTo.vue";
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
//

import nyTit1 from '@/components/nyTit1.vue'
import leftPie from "@/components/sanchan1/left_pie";
import leftLine from "@/components/sanchan1/left_line";
import leftBar from "@/components/sanchan1/left_bar";
import rightPie from "@/components/sanchan1/right_pie";
import footer1 from "../components/footer.vue";

export default {
  name: "Home",
  setup() {
    const { appContext } = getCurrentInstance();
    const timer = ref(null);
    const router = useRouter();
    const state = reactive({
      url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      leftData1: [
        { name: "2023年电商销售总额", value: 2900, unit: "万" },
        { name: "2024年电商销售总额", value: 3010, unit: "万" },
        { name: "2025年电商销售总额", value: 3229.8, unit: "万" },
      ],
      options: {
        src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/sc/sgs.mp4", //视频源
        type: "video/mp4", //视频类型
      },
      options1: {
        src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/sc/2jiagong.mp4", //视频源
        type: "video/mp4", //视频类型
      },
      options2: {
        src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/sc/3zhongzhi02.mp4", //视频源
        type: "video/mp4", //视频类型
      },
      leftData3: [
        { value: 3110, name: "2018" },
        { value: 4140, name: "2019" },
        { value: 6100, name: "2020" },
        { value: 7400, name: "2021" },
        { value: 8650, name: "2022" },
        { value: 9750, name: "2023" },
      ],
      tData6: [
        { name: "丝瓜水" ,path:"/sanchan1"},
        { name: "红薯" ,path:"/sanchan1_hongshu"},
        { name: "营养餐" ,path:"/yingyangcan"},
        // { name: "黄姜" },
        // { name: "食用菌" },
        // { name: "醋" },
      ],
      leftData:[
        {
          title:"打造全省领先的县级电商基地",
          list:["专业团队  ： 山东易谷商业运营管理有限公司","完备设施   ：13个标准直播间","优惠政策  ：租金减免 税收优惠 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;规模扶持 示范激励"],
          icon:require('../assets/img/sanchan1/ds.png')
        },
        {
          title:"筛选优质企业入驻园区免费孵化陪跑",
          list:["孵化成功的企业搬离园区，扩大规模","筛选孵化新一批企业"],
          icon:require('../assets/img/sanchan1/yq.png')
        },
        {
          title:"推动实现孵化、发展、孵化长期循环",
          list:["已成功孵化电商企业11家，加工企业5家","正在孵化电商企业12家，加工企业7家"],
          icon:require('../assets/img/sanchan1/ds.png')
        }
      ]
    });
    onMounted(() => {
      // setInterval(() => {
      //   state.showDiv = !state.showDiv
      // }, 6000);
    });
    onUnmounted(() => {});
    onBeforeUnmount(() => {});
    // 返回上一页
    function clickReturn() {
      router.go(-1);
    }
    function tabcp(e) {
      console.log(e.rowIndex);
    }
    return {
      ...toRefs(state),
      close,
      clickReturn,
      tabcp,
    };
  },
  components: {
    nyTit1,
    leftPie,
    leftLine,
    leftBar,
    rightPie,
    footer1,
  },
};
</script>
<style lang="less" scoped>
a {
  color: #fff;
}
body {
  background-size: cover;
  line-height: 1.15;
}
@font-face {
  font-family: electronicFont;
  src: url("../assets/font/DS-DIGIT.TTF");
}

#video .d-player-wrap {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}

// 修改右侧产品带货列表列表样式
::v-deep .dv-scroll-board .rows .row-item,
::v-deep .dv-scroll-board .header {
  font-size: 26px;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
}
::v-deep .dv-scroll-board .rows .row-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.container {
  width: 100%;
  height: 100vh;
  background: url("../assets/img/sanchan1/bj.jpg") no-repeat top center;
  background-size: 100% 100% !important;
  color: #fff;
  position: relative;
  .content {
    position: absolute;
    top: 150px;
    left: 0;
    width: 100%;
    height: calc(100vh - 150px);
    display: flex;
    position: relative;
    padding: 0 45px 80px;
    box-sizing: border-box;
    // 左侧
    .rightBox {
      width: 780px;
    }
    .leftBox {
      width: 830px;
      height: 100%;
      background: url("../assets/img/sanchan1/z1.png") no-repeat;
      background-size: 100% 100% !important;
      display: flex;
      flex-direction: column;
      padding: 0 20px;
      box-sizing: border-box;
      .leftBox3{
        .title1{
          margin: 50px 0;
        }
        .left_list{
          .left_list_item0{
            margin: 20px 0;
            .jiantouLeft{
              margin: 10px 0;
            }
          }
          .left_list_item{
            border: 1px solid #01C4BF;
            padding: 24px 20px;
            text-align: left;
            h5{
              color: #01C4BF;
              font-size: 28px;
              margin-bottom: 10px;
            }
            .left_list_item_bottom{
              display: flex;
              align-items: center;
              img{
                width: 94px;
                height: 96px;
                margin-right: 40px;
              }
              .left_list_item_r{
                flex: 1;
                .left_list_item_r_item{
                  display: flex;
                  margin: 20px 0;
                  font-size: 28px;
                  line-height: 46px;
                  span:first-child{
                    display: block;
                    width: 46px;
                    height: 46px;
                    border: 2px solid #04576F;
                    text-align: center;
                    line-height: 44px;
                    margin-right: 20px;
                    flex-shrink: 0;
                  }
                }
              }
            }
          }
        }
      }
    
    }
    .center {
      flex: 1;
      flex-shrink: 0;
      height: 100%;
      padding-top: 240px;
      box-sizing: border-box;
      display: flex;
      margin: 0 120px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      .jian_kong_fc1 {
          width: 100%;
          height: 90px;
          background: rgba(7, 72, 112, 0.2);
          position: absolute;
          top: 8%;
          left:0%;
          span{
            font-size: 60px;
            line-height: 100px;
            z-index: 999;
            background: linear-gradient(180deg, #fff 25%, #abdfff 95%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-weight: 700;
            letter-spacing: 20px;
          }
          
        }
      .img {
        height: 100%;
        background-size: 100% 100% !important;
        padding: 43px 36px;
        box-sizing: border-box;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .jian_kong_fc {
          width: 95%;
          height: 90px;
          line-height: 90px;
          background: rgba(7, 72, 112, .8);
          position: absolute;
          top: 0.5%;
          left:2.5%;
          font-size: 30px;
          z-index: 999;
        }
      }
      .img1 {
        width: 1380px;
        background: url("../assets/img/sanchan1/zk.png") no-repeat;
      }
      .img2 {
        width: 1380px;
        height: 98%;
        background: url("../assets/img/sanchan1/tuk.png") no-repeat;
        margin: 4% 0;
      }
      .img3 {
        width: 1380px;
        background: url("../assets/img/sanchan1/yk.png") no-repeat;
      }
      .jiantou {
        width: 73px;
        height: 88px;
        margin: 0 20px;
      }
    }
    // 右側
    .rightBox {
      height: 100%;
      display: flex;
      flex-direction: column;
      .leftBox1 {
        width: 100%;
        height: 140px;
        display: flex;
        flex-direction: column;
        .leftContent1 {
          width: 100%;
          flex: 1;
          display: flex;
          justify-content: space-between;
          padding: 0 40px;
          margin-top: 30px;
          .leftContent1_item {
            display: flex;
            flex-direction: column;
            margin: 0 20px;
            .leftContent1_item_name {
              font-size: 20px;
              color: #d0deee;
              line-height: 30px;
            }
            .leftContent1_item_value {
              font-size: 40px;
              color: #00ffea;
              margin-top: 5px;
              i {
                font-size: 24px;
                color: #d0deee;
                margin-left: 10px;
              }
            }
          }
        }
      }
      .leftBox2 {
        width: 100%;
        height: 300px;
        display: flex;
        flex-direction: column;
      }
      .rightBox1 {
        width: 100%;
        height: 386px;
        background: url("../assets/img/sanchan1/y1.png") no-repeat;
        display: flex;
        flex-direction: column;

        .rightContent1 {
          padding: 20px 50px;
          overflow: hidden;
        }
        .dao_hang {
          width: 130px;
          height: 200px;
          position: absolute;
          display: flex;
          flex-direction: column;
          right: 20px;
          top: 38%;
          z-index: 1;
          .biao_ti_name {
            width: 100%;
            flex: 1;
            margin: 8px 0;
            background-color: #0e4275;
            position: relative;
            a{
              display: block; 
              font-size: 25px;
              line-height: 48px;
              width: 100%;
              height: 100%;
              color: #fff;
              position: absolute;
            }
          }
        }
      }
      .rightBox2 {
        width: 100%;
        flex: 1;
        background: url("../assets/img/sanchan1/y2.png") no-repeat;
        display: flex;
        flex-direction: column;
        .rightTit {
          margin: 30px 40px 30px;
        }
        .area {
          width: 704px;
          height: 60px;
          background: #042446;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          line-height: 60px;
          .area_left {
            display: flex;
            font-size: 30px;
            img {
              width: 40px;
              height: 40px;
              margin: 10px 30px 0 50px;
            }
          }
          .area_right {
            font-size: 30px;
            margin-right: 50px;
            display: flex;
            span {
              display: block;
              color: #ffd15d;
              font-size: 40px;
              margin-right: 10px;
            }
          }
        }
      }
    }
    .echartBox {
      width: 100%;
      flex: 1;
    }

    // 标题
    .title {
      width: 100%;
      height: 60px;
      background: url("../assets/img/sanchan1/xbt.png") no-repeat;
      text-align: left;
      padding-left: 50px;
      line-height: 60px;
      .txt1 {
        font-size: 34px;
        background: linear-gradient(to bottom, #fff 25%, #abdfff 95%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-style: italic;
        font-weight: bold;
        padding: 0 10px;
      }
      .txt2 {
        color: #0287ba;
        margin-left: 40px;
        font-size: 26px;
        font-family: Arial, Helvetica, sans-serif;
        font-weight: bold;
      }
    }
    .title1 {
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: url("../assets/img/sanchan1/zb.png") no-repeat left bottom;
      color: #d2e2f2;
      font-size: 30px;
      text-align: left;
      margin-left: 40px;
      padding-left: 20px;
      box-sizing: border-box;
      font-weight: bold;
    }
  }
}

// 轨道旋转动画b
@keyframes spin {
  0% {
    transform: scaleY(0.5) rotate(0deg);
  }
  100% {
    transform: scaleY(0.5) rotate(360deg);
  }
}
@keyframes anti-spin {
  0% {
    transform: rotate(0deg) scaleY(2) scale(1);
  }
  100% {
    transform: rotate(-360deg) scaleY(2) scale(1);
  }
}
// 轨道

@keyframes scale1 {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scale {
  0% {
    transform: scale(1);
  }
  50%,
  75% {
    transform: scale(2);
  }
  78%,
  100% {
    opacity: 0;
  }
}
@keyframes title {
  0% {
    background-position: 0 bottom;
  }
  50% {
    background-position: 10px bottom;
  }
  100% {
    background-position: 0 bottom;
  }
}
@keyframes bianda {
  0% {
    // transform: scale(0.96);
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0));
  }
  50% {
    // transform: scale(1);
    filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.5));
  }
  100% {
    // transform: scale(0.96);
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0));
  }
}
@keyframes jiantou {
  0% {
    right: 90px;
  }

  50% {
    right: 95px;
  }
  100% {
    right: 90px;
  }
}

@keyframes guangying {
  0% {
    transform: scale(0.96);
    filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
  }

  50% {
    transform: scale(1);
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
  }
  100% {
    transform: scale(0.96);
    filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
  }
}

@keyframes rightCircle {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes rotate {
  0% {
    transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(0deg) rotateY(0deg) rotateZ(360deg);
  }
}

// 左侧矩形
@keyframes leftJx {
  /*引用动画名称*/
  0% {
    box-shadow: inset 0 0 5px 2px rgba(55, 199, 219, 0.5);
  }
  50% {
    box-shadow: inset 0 0 10px 2px rgba(55, 199, 219, 0.5);
  }

  100% {
    box-shadow: inset 0 0 5px 2px rgba(55, 199, 219, 0.5);
  }
}
</style>
